import React, { ReactNode } from "react";

interface IWebsiteBuilderPopupRowProps {
  children: ReactNode;
}

export function WebsiteBuilderPopupRow(props: IWebsiteBuilderPopupRowProps) {
  const { children } = props;

  return <div className="website-builder-popup-row">{children}</div>;
}
